(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/oddset-categorized/assets/javascripts/oddset-categorized.js') >= 0) return;  svs.modules.push('/widgets/oddset-categorized/assets/javascripts/oddset-categorized.js'); 'use strict';

var _svs$components = svs.components,
    ContentReveal = _svs$components.ContentReveal,
    Storage = _svs$components.Storage,
    analytics = _svs$components.analytics,
    loader = _svs$components.loader,
    Alert = _svs$components.Alert;
var _svs$core = svs.core,
    jupiter = _svs$core.jupiter,
    socket = _svs$core.socket,
    _module = _svs$core.module,
    userSession = _svs$core.userSession,
    detect = _svs$core.detect;
var _svs$oddset = svs.oddset,
    STATE_OPEN = _svs$oddset.STATE_OPEN,
    REGULAR = _svs$oddset.REGULAR,
    STATE_CLOSED = _svs$oddset.STATE_CLOSED,
    STATE_CLOSED_REGULAR = _svs$oddset.STATE_CLOSED_REGULAR;
var isHighlightedLeague = svs.sport.sport_common.isHighlightedLeague;
var createInit = svs.sport.matchInitBoxLight.createInit;
var _svs$sport$oddsetComm = svs.sport.oddsetCommon.common,
    formatDrawData = _svs$sport$oddsetComm.formatDrawData,
    getMostPlayedDrawEvents = _svs$sport$oddsetComm.getMostPlayedDrawEvents;
var _svs$widget$oddset_ca = svs.widget.oddset_categorized,
    mapSearchPayloadToObject = _svs$widget$oddset_ca.mapSearchPayloadToObject,
    mapDraw = _svs$widget$oddset_ca.mapDraw,
    handleMostPlayedResponse = _svs$widget$oddset_ca.handleMostPlayedResponse,
    addTrackingId = _svs$widget$oddset_ca.addTrackingId;
var FILTER_BUTTON_SELECTOR = '.js-oddset-categorized-select-filter-button';
var DRAWS_CONTAINER_SELECTOR = '.js-oddset-categorized-draws-container';
var BET_BUTTON_SELECTOR = '.js-oddset-categorized-button';
var BET_PANEL_SELECTOR = '.js-oddset-categorized-panel';

function init(options) {
  var $el = options.$el;
  var contentReveal = new ContentReveal({
    el: $el.find('.js-oddset-categorized-widget')
  });
  var el = options.$el.get(0);
  var sport = getSport(el);
  var selectedButton = el.querySelector(FILTER_BUTTON_SELECTOR);
  var objects = svs.widget.oddset_categorized.data.model && svs.widget.oddset_categorized.data.model.draws;
  initFilterListeners();
  initObjectClickListeners();
  startSubscription(objects);

  function initFilterListeners() {
    if (el) {
      var filterEls = Array.prototype.slice.call(el.querySelectorAll(FILTER_BUTTON_SELECTOR));
      filterEls.forEach(function (filterEl) {
        filterEl.addEventListener('click', handleFilterClick);
      });
    }
  }

  function handleFilterClick(e) {
    if (selectedButton === e.target) {
      return;
    }

    var leagueId = e.target.getAttribute('data-league-id');

    if (selectedButton) {
      selectedButton.classList.toggle('btn-transparent-default');
      selectedButton.classList.toggle('btn-inverted');
    }

    selectedButton = e.target;
    e.target.classList.toggle('btn-transparent-default');
    e.target.classList.toggle('btn-inverted');
    fetchObjects(leagueId);
  }

  function fetchObjects(leagueId) {
    if (leagueId) {
      jupiter.get("/search/1/query?ctx=draw&type=oddsetlist&infilter=payload.draw.league.uniqueLeagueId;".concat(leagueId, "&sort=payload.draw.regCloseTime;asc"), function (response) {
        var objects = response.result.map(mapSearchPayloadToObject(sport)).filter(Boolean).map(addTrackingId);
        reinitialize(objects.slice(0, 12));
      });
    } else {
      getMostPlayedDrawEvents({}, function (err, draws) {
        var objects = handleMostPlayedResponse({
          sport: sport,
          draws: draws
        });
        reinitialize(objects);
      });
    }
  }

  function initObjectClickListeners() {
    Array.prototype.slice.call(el.querySelectorAll(BET_BUTTON_SELECTOR)).forEach(function (el) {
      el.addEventListener('click', playNow);
    });
    Array.prototype.slice.call(el.querySelectorAll(BET_PANEL_SELECTOR)).forEach(function (el) {
      el.addEventListener('click', drawLink);
    });
  } 


  var storedPlayNow = Storage.browser.get('oddsetMostPlayed', 'playnow');

  if (storedPlayNow && Object.prototype.hasOwnProperty.call(storedPlayNow, 'drawId') && Object.prototype.hasOwnProperty.call(storedPlayNow, 'eventNumber')) {
    showPlayNow(storedPlayNow);
  }

  function reinitialize(draws) {
    contentReveal.destroy();
    var model = {
      draws: draws,
      useScroll: detect.formfactor.mobile()
    };
    el.querySelector(DRAWS_CONTAINER_SELECTOR).innerHTML = svs.widget.oddset_categorized.templates.draws_container(model);
    contentReveal = new ContentReveal({
      el: $el.find('.js-oddset-categorized-widget')
    });
    initObjectClickListeners();
    objects.forEach(function (object) {
      unsubscribeDrawEvent(object.draw.id);
    });
    objects = draws;
  }

  function startSubscription(objects) {
    objects.forEach(function (object) {
      if (object && object.draw) {
        update(object.draw);
        subscribeDrawEvent(object.draw.draw.id);
      }
    });
  }

  function subscribeDrawEvent(drawId) {
    if (!svs.oddset.global) {
      socket.subscribe(subscriptionUrl(drawId), update, {});
    }
  }

  function subscriptionUrl(drawId) {
    return "/draw/1/oddset/draws/".concat(drawId, "/list");
  }

  function unsubscribeDrawEvent(drawId) {
    socket.unsubscribe(subscriptionUrl(drawId), update);
  }

  function update(drawObject, oldDrawId) {
    var draw = parseDraw(drawObject);
    var drawData = null;

    if (draw && (draw.drawStateId === STATE_CLOSED || draw.drawStateId === STATE_CLOSED_REGULAR)) {
      unsubscribeDrawEvent(draw.id); 

      if (draw.categoryId === REGULAR && draw.relatedLiveDrawNumber !== 0) {
        transitionToLive(draw);
      } else {
        handleGameNotFound(draw.id);
      }
    } else if (draw && parseDrawEvent(draw)) {
      drawData = formatDrawData(draw, true);
      render({
        draw: mapDraw(drawData),
        initObject: createInit(drawData.draw)
      }, oldDrawId);
    } else {
      handleGameNotFound(draw.id);
    }
  }

  function render(model, drawId) {
    if (!el) {
      return;
    }

    var drawEl = el.querySelector(".js-oddset-categorized-draw-".concat(drawId && typeof drawId === 'number' ? drawId : model.draw.draw.id));

    if (!drawEl) {
      return;
    }

    if (model && model.draw && model.draw.draw && model.draw.draw.league && model.draw.draw.league.id) {
      model.draw.draw.isHighLeague = isHighlightedLeague(model.draw.draw.league.id);
    }

    var betPanelEl = drawEl.querySelector(BET_PANEL_SELECTOR);

    if (!betPanelEl) {
      return;
    }

    model.trackingId = betPanelEl.getAttribute('data-track');
    model.areaName = betPanelEl.getAttribute('data-area-name');
    drawEl.innerHTML = svs.widget.oddset_categorized.templates.draw(model);
    $(drawEl).data('draw', model.draw);
    Array.prototype.slice.call(drawEl.querySelectorAll(BET_BUTTON_SELECTOR)).forEach(function (el) {
      el.addEventListener('click', playNow);
    });
    betPanelEl.addEventListener('click', drawLink);
  }

  function transitionToLive(draw) {
    jupiter.get("/draw/1/mixen/draws/".concat(draw.relatedLiveDrawNumber), function (data) {
      if (data && data.draw && data.draw.id) {
        update(data, draw.id);
        subscribeDrawEvent(data.draw.id);
      }
    });
  }

  function parseDraw(drawObject) {
    if (drawObject && drawObject.draw) {
      return drawObject.draw;
    }
  }

  function parseDrawEvent(draw) {
    if (!draw.events || draw.events === 0 || draw.events.length === 0) {
      return false;
    }

    if (draw.events[0].eventStateId !== STATE_OPEN) {
      return false;
    }

    return true;
  }

  function trackClick(el, callback) {
    var $el = $(el);
    var track = $el.data('track');
    var areaName = $el.data('areaName') || 'unknown';

    if (track) {
      analytics.trackPromoClick({
        id: track,
        name: track,
        position: areaName
      }, callback);
    }
  }

  function drawLink(e) {
    e.preventDefault();
    var url = $(this).attr('href');
    trackClick(this, function () {
      window.location.href = url;
    });
  }


  function showPlayNow(options) {
    var $drawEl = $(".js-oddset-categorized-draw-".concat(options.drawId));
    loader.show();

    _module.load('/cl/sport/oddset-play', null, function (error) {
      if (error) {
        loader.hide();
        Alert('Kunde inte ladda spelet - Försök igen!', {
          time: Alert.Time.SHORT,
          type: Alert.Type.ERROR
        }).show(null);
      } else {
        svs.sport.oddsetplay.showPlayNow(options.drawId, options.eventNumber, options.description, $.data($drawEl, 'draw'));
      }
    }, false);
  }

  function playNow(e) {
    e.stopPropagation();
    e.preventDefault();
    trackClick(this);
    var drawId = $(this).data('draw-id');
    var game = {
      description: $(this).data('event-description'),
      drawId: drawId,
      eventNumber: $(this).data('event-number')
    }; 

    Storage.browser.remove('oddsetMostPlayed', 'playnow', function () {
      if (!userSession.hasRole(userSession.roles.PLAYER)) {
        Storage.browser.set('oddsetMostPlayed', 'playnow', game, undefined);
      }

      showPlayNow(game);
    });
  }

  function handleGameNotFound(drawId) {
    var $drawEl = $(".js-oddset-categorized-draw-".concat(drawId));
    render({
      draw: null
    }, drawId);

    if (contentReveal) {
      $drawEl.parents('.js-content-reveal-list-item').addClass('content-reveal-list-item-hidden');
      contentReveal.resize();
    } else {
      $drawEl.addClass('oddset-categorized-draw-hidden');
    }
  }
}

function getSport(el) {
  if (!el) {
    return null;
  }

  return Number(el.getAttribute('data-sport'));
}

setGlobal('svs.widget.oddset_categorized.init', init);
 })(window);